import { OptionsClass } from "./MainApp";

export class IntegrationApi {
  id = 0;
  platform: OptionsClass | "" = "";
  appName = "";
  domain = "";
  status = "";
  clientKey = "";
  clientSecret = "";
  createdAt = "";

  constructor(fields?: Partial<IntegrationApi>) {
    Object.assign(this, fields);
  }
}
